import { render } from "./daydetail.vue?vue&type=template&id=60c79cb4"
import script from "./daydetail.vue?vue&type=script&lang=js"
export * from "./daydetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jx/project/wld/nongxin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__